












































































































import { SharedState } from "@/common/state";
import RegulatedDashboardItem from "./RegulatedDashboardItem.vue";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import DashboardItem from "../../../../common/DashboardItem.vue";
import { BaseDashboardItem } from "../data/models";
import { state } from "./state";
import Sensitivities from "@/components/filters-bar/Sensitivities.vue";
import { UseModal } from "@/components/root/modal";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import { AxisType, CoordinateInputTier3 } from "@/gql/types";
import { cord, cord3 } from "@/gql/lib";
import InfoTypeCountsModalVue from "@/components/modals/info-types-counts-modal/InfoTypeCountsModal.vue";
import { InfoTypesCountModalProps } from "@/components/modals/info-types-counts-modal/model";
import { InformationType } from "@/common/models";
import { UseTabs } from "@/common/composition/use-tabs";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import PIIBoard from "./pii-dashboard/PIIBoard.vue";

export default Vue.extend({
  components: {
    DashboardItem,
    RegulatedDashboardItem,
    Sensitivities,
    SimpleNavTabs,
    PIIBoard,
  },
  setup(_, { root: { $router } }) {
    const [tabs, selected_tab, set_selected_tab] = UseTabs<{
      id: string;
      name: string;
      icon: string;
      enabled: boolean;
    }>(
      [
        {
          id: "sensitive",
          name: "Sensitive Information",
          icon: "Label",
          enabled: true,
        },
        {
          id: "personal",
          name: "Personal Information",
          icon: "Regulated",
          enabled: true,
        },
        {
          id: "other",
          name: "Other",
          icon: "Other",
          enabled: SharedState.FeatureHelper.is_enabled("expose_other"),
        },
      ].filter((d) => d.enabled),
      0
    );

    const {
      display_items,
      init,
      is_loading,
      sensitivities,
      toggle_sensitivity,
      ms_coverage_count,
    } = state;
    const frame_date = computed(
      () => SharedState.selectedTimeFrameDisplayName.value
    );

    onMounted(() => {
      SharedState.onReady(async () => {
        await init();
      });
    });

    onBeforeUnmount(() => state.destroy());

    const on_item_clicked = async (item: BaseDashboardItem) => {
      SharedState.ifIsPayingUser(
        async () => {
          const info_type = SharedState.getInfoType(item.id)!;
          if (SharedState.restrictions.is_restricted_info(info_type.code)) {
            SharedState.restrictions.show_restrictions_modal(
              "info",
              info_type.labelName
            );
            return;
          }
          const { type, from } = SharedState.selectedTimeFrameOption.value;
          await UseModal().show(EventsModalVue, {
            title: `Events which involved <b>${item.name}</b> information`,
            files_title: `<b>${item.name}</b> information files`,
            coordinates: [
              {
                x: cord3(AxisType.None, []),
                y: cord3(AxisType.ContentLabel, [item.id]),
                z: {
                  type,
                  values: [from],
                },
              },
            ] as CoordinateInputTier3[],
          } as EventsModalProps);
        },
        { premium_modal_key: "what-popup-2024" }
      );
    };

    const show_more = async (id: string) => {
      const { type, from } = SharedState.selectedTimeFrameOption.value;
      const label = SharedState.allInfoTypes.value[id];

      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          label.labelName
        );
        return;
      }

      const l1s = (SharedState.typesByCategories.value.get(
        id
      ) as InformationType[]).map((d) => d.id);

      const modalProps: InfoTypesCountModalProps = {
        title: `<b>${label.name}</b>`,
        files_title: `<b>${label.name}</b> Files`,
        info_type: label.id,
        coordinate: {
          x: cord(AxisType.None, []),
          y: {
            type: AxisType.ContentLabel,
            values: [label.id, ...l1s],
          },
          z: {
            type,
            values: [from],
          },
        },
        events: {
          title: (entity, info_type_id) => {
            return `Events involving <b>${entity.name}</b> information`;
          },
          coordinate: (entity, info_type_id) => {
            return {
              x: cord(AxisType.None, []),
              y: {
                type: AxisType.ContentLabel,
                values: [entity.id],
              },
              z: {
                type,
                values: [from],
              },
            };
          },
        },
      };
      await UseModal().show(InfoTypeCountsModalVue, modalProps);
    };
    return {
      feature_pii: SharedState.FeatureHelper.is_enabled("pii_labeler"),
      // tabs
      tabs,
      selected_tab,
      set_selected_tab,
      // rest
      sensitivities,
      toggle_sensitivity,
      frame_date,
      is_loading,
      regular_content_types_items: computed(() =>
        display_items.value.slice(0, display_items.value.length - 1)
      ),
      other_item: computed(() => {
        const other = display_items.value[display_items.value.length - 1];
        /*      other.items = other.items.filter(
          (d: { id: string }) => d.id !== SharedState.default_label_id.value
        ); */
        return other;
      }),
      ms_coverage_count,
      on_item_clicked,
      show_more,
      user_has_ms: SharedState.data_sources_includes_ms,
      feature_custom_info_type_enabled: computed(() =>
        SharedState.FeatureHelper.is_enabled("custom_information_type")
      ),
      nav_to_create_custom_info_type: () => {
        $router.push({
          name: "InformationCustomization",
          query: { action: "add_custom" },
        });
      },
    };
  },
});
